import React from 'react';
import Hero from './../components/Hero';
import TwoColumnsContent from './../components/TwoColumnsContent';
import QuoteForm from './../components/QuoteForm';
import { Grid } from "react-bootstrap";

class Quote extends React.Component{
    render(){
        return(
            <Grid fluid>
                <Hero title={"Cotizar"} />
                <TwoColumnsContent />
                <QuoteForm />
            </Grid>
        )
    }
}

export default Quote;


// WEBPACK FOOTER //
// ./src/containers/Quote.js